import { FormattedMessage } from 'react-intl';

export default FormattedMessage;
